import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import Footer from '../../Componants/Footer/Footer.jsx';
import { Link } from 'react-router-dom';
import homelogo from '../../Images/homelog.svg';
import { FaWhatsapp } from 'react-icons/fa';
import phone from '../../Images/Phones.png';
import fanzpick from '../../Images/fanzpicks.svg';
import googleplay_ from '../../Images/gplay.svg';
import googleplay from '../../Images/google.png';
import appstore from '../../Images/app.png';
import appstore_ from '../../Images/appsstore.svg';
import goalserve from '../../Images/goalserve.png';
import { useDispatch, useSelector } from 'react-redux';
import { DynamicImage } from '../../Utilities/Redux/Services/FAQ.Services.js';
import { IMAGE_URL } from '../../Common/Constant/Index.js';
function Home() {
  const dispatch = useDispatch();
  // Updated selector to get the correct state
  const { getDynamicImage, loading, error } = useSelector(
    (state) => state.FAQ || {}
  );
  const [phoneImage, setPhoneImage] = useState(phone); // Default fallback image
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Fetch page data with your specific slug
    dispatch(DynamicImage({ slug: 'home' })); // Replace "home" with your actual slug
  }, [dispatch]);

  useEffect(() => {
    // Update phone image when API data is received
    if (getDynamicImage && getDynamicImage.data) {
      setPhoneImage(getDynamicImage?.data?.content);
    }
  }, [getDynamicImage]);

  console.log('IMAGE:::::::', IMAGE_URL + phoneImage);
  // useEffect(()=>{
  //   window.scrollTo({top:0, behavior:"smooth"})
  // },[])
  return (
    <>
      <div className={styles.home}>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.headerLeft}>
              <img src={homelogo} alt='Fanzpick Logo' />
            </div>
            <div className={styles.headerRight}>
              <a
                href='https://wa.me/447383825379'
                target='_blank'
                rel='noopener noreferrer'
                className={styles.whatsappContact}
              >
                <FaWhatsapp className={styles.whatsappIcon} />
                {/* <span className={styles.phoneNumber}>+44 7383 825379</span> */}
              </a>
            </div>
          </div>
          <div className={styles.horizontalLine}></div>
          <div className={styles.homeinner}>
            <div className={styles.home_left}>
              <div className={styles.leftImg}>
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL_IMAGE}${phoneImage}`}
                  alt='imgs'
                />
              </div>
            </div>
            <div className={styles.home_right}>
              <h3>Welcome To</h3>
              <div className={styles.fanzpicklogo}>
                <img src={fanzpick} alt='imgs' />
              </div>
              <div className={styles.buttons}>
                <Link
                  to={
                    'https://play.google.com/store/apps/details?id=com.fanzpick&hl=en_IN'
                  }
                  target='_blank'
                >
                  <img src={googleplay} alt='imgs' />
                </Link>
                <Link
                  to={'https://apps.apple.com/us/app/fanzpick/id6449597077'}
                  target='_blank'
                >
                  <img src={appstore} alt='imgs' />
                </Link>
              </div>
              <h4>Data Provided By</h4>
              <div className={styles.goalserve}>
                <img src={goalserve} alt='imgs' />
              </div>
            </div>
          </div>
        </div>
        <div style={{ float: 'right' }} className={styles.footerHome}>
          {' '}
          <Footer customClass={styles.customFooter}>
            <div className={styles.customFooter_textRight}>
              ©{new Date().getFullYear()} Fanzpick - All rights reserved.
            </div>
          </Footer>
        </div>
      </div>
    </>
  );
}

export default Home;
